module.exports = __webpack_public_path__ + "static/media/15.ac37479d.jpg";